// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-up-tray.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-up-tray',
  version: 'outline',
  paths: [
    {
      d: 'M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5',
    },
  ],
}
